import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import baseConfig from "../../config/config";

export const fetchTableData = createAsyncThunk("request/filter", async () => {
  try {
    let csrfToken=localStorage.getItem("csrfToken")
    const res = await axios.post(
      baseConfig.apiBaseUrl + "/request/filter",
      {}, 
      {
        headers: {
          "Content-Type": "application/json",
          "serviceid": sessionStorage.getItem("userToken"),
          "X-CSRF-Token": csrfToken
        },
        withCredentials:true,
      }
    );
    const data = res.data;
    return { data };
  } catch (error) {
    throw error;
  }
});

export const getDistinctDataThroughSingleApi = createAsyncThunk(
  "getDistinctDataThroughSingleApi",
  async () => {
    try {
      const res = await axios(
        baseConfig.apiBaseUrl  + `/utility/table/reference`,
        {
          headers: {
            "Content-Type": "application/json",
            "serviceid":sessionStorage.getItem("userToken")
          },
        }
      );
      const data = res.data;
      return { data: data };
    } catch (error) {
      throw error;
    }
  }
);

export const fetchGPUData = createAsyncThunk(
  "fetchGPUData",
  async () => {
    try {
      let csrfToken=localStorage.getItem("csrfToken")
      const res = await axios.post(
        baseConfig.apiBaseUrl + `/available/gpu/list`,
        {
          GPU_Names: "All"
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "serviceid": sessionStorage.getItem("userToken"),
            "X-CSRF-Token": csrfToken
          },
          withCredentials: true,
        }
      );
      const data = res.data;
      return { data: data };
    } catch (error) {
      throw error;
    }
  }
);

export const fetchRegionData = createAsyncThunk(
  "fetchRegionData",
  async () => {
    try {
      const res = await axios(
        baseConfig.apiBaseUrl  + `/request/region/GetRegionsToDelete`,
        {
          headers: {
            "Content-Type": "application/json",
            "serviceid":sessionStorage.getItem("userToken")
          },
        }
      );
      const data = res.data;
      return { data: data };
    } catch (error) {
      throw error;
    }
  }
);

export const deleteRegions = createAsyncThunk(
  "deleteRegions",
  async (regionIds, { rejectWithValue }) => {
    try {
      let csrfToken=localStorage.getItem("csrfToken")
      const response = await axios.post(
        baseConfig.apiBaseUrl + `/request/region/DeleteRegions`,
        JSON.stringify(regionIds),
        {
          headers: {
            "Content-Type": "application/json",
            "serviceid": sessionStorage.getItem("userToken"),
            "X-CSRF-Token": csrfToken
          },
          withCredentials: true
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting regions:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getEarlyAccessTabledata = createAsyncThunk(
  "getEarlyAccessTableData",
  async () => {
    try {
      const payload = {
        "CustomerType": null,
        "RequestState": null,
        "Model": null,
        "Tag": null,
        "RequestGranted": null,
        "CustomerEmail": null
      }
      let csrfToken=localStorage.getItem("csrfToken")

      const res = await axios.post(
        baseConfig.apiBaseUrl + `/EARequest/ListRequests`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "serviceid":sessionStorage.getItem("userToken"),
            "X-CSRF-Token": csrfToken
          },
          withCredentials: true,

        }
      );
      const data = res.data;
      return { data: data };
    } catch (error) {
      throw error;
    }
  }
);